export type ShopCategory = "styling" | "haircare" | "beard" | "aftershave" | "hair";

export interface ShopProduct {
  id: string;
  category: ShopCategory;
  name: string;
  brand: string;
  subtitle?: string;
  description: string;
  shortDescription: string;
  variants: Array<{ volume: string | null; price: number }>;
  priceFrom: number;
  tags: string[];
  image: string;
  isNew?: boolean;
  aiContext?: string;
}

export const shopProducts: ShopProduct[] = [
  {
    id: "morgans-beard-shampoo",
    category: "beard",
    name: "Шампунь для бороды",
    brand: "MORGAN'S",
    subtitle: "Эффективно очищает, увлажняет и смягчает бороду",
    description:
      "Шампунь для бороды Morgan's эффективно очищает, увлажняет и смягчает бороду и усы. Подходит для регулярного ухода и помогает сохранить аккуратный вид. Объем: 100 мл.",
    shortDescription: "Эффективно очищает, увлажняет и смягчает бороду и усы.",
    variants: [{ volume: "100 мл", price: 2200 }],
    priceFrom: 2200,
    tags: ["Очищение", "Увлажнение"],
    image: "/products/morgans-beard-shampoo-clean.png",
    aiContext: "beard shampoo, cleansing, moisturizing, soft beard, Morgan's, beard care",
  },
  {
    id: "morgans-beard-mustache-cream",
    category: "beard",
    name: "Крем для бороды и усов",
    brand: "MORGAN'S",
    subtitle: "Увлажнение, питание и мягкость бороды",
    description:
      "Крем Morgan's для бороды и усов смягчает, увлажняет и помогает сделать бороду более послушной. Подходит для ухода за бородой и усами после очищения. Объем: 75 мл.",
    shortDescription: "Смягчит, увлажнит и улучшит внешний вид бороды и усов.",
    variants: [{ volume: "75 мл", price: 1700 }],
    priceFrom: 1700,
    tags: ["Увлажнение", "Питание"],
    image: "/products/morgans-beard-cream-clean.png",
    aiContext: "beard cream, moustache cream, moisturizing, nourishing, Morgan's, beard care",
  },
  {
    id: "davines-energizing-shampoo",
    category: "hair",
    name: "Энергетический шампунь",
    brand: "Davines Naturaltech",
    subtitle: "Против выпадения и для стимуляции роста",
    description:
      "Энергетический шампунь Davines Naturaltech помогает ухаживать за кожей головы при склонности к выпадению волос, освежает и поддерживает ощущение тонуса. Объем: 250 мл.",
    shortDescription: "Для ухода за кожей головы, стимуляции роста и профилактики выпадения.",
    variants: [{ volume: "250 мл", price: 3300 }],
    priceFrom: 3300,
    tags: ["Против выпадения", "Стимуляция роста"],
    image: "/products/davines-energizing-shampoo-clean.png",
    aiContext: "energizing shampoo, Davines Naturaltech, hair loss, scalp stimulation, hair care",
  },
  {
    id: "davines-anti-dandruff-shampoo",
    category: "hair",
    name: "Шампунь против перхоти",
    brand: "Davines Naturaltech",
    subtitle: "От перхоти и зуда кожи головы",
    description:
      "Шампунь Davines Naturaltech Purifying помогает ухаживать за кожей головы при перхоти и ощущении зуда, мягко очищает и поддерживает комфорт. Объем: 250 мл.",
    shortDescription: "Для ухода за кожей головы при перхоти и ощущении зуда.",
    variants: [{ volume: "250 мл", price: 3300 }],
    priceFrom: 3300,
    tags: ["От перхоти", "Снятие зуда"],
    image: "/products/davines-purifying-shampoo-clean.png",
    aiContext: "purifying shampoo, anti dandruff, Davines Naturaltech, itchy scalp, hair care",
  },
  {
    id: "davines-solu-shampoo",
    category: "hair",
    name: "Очищающий шампунь",
    brand: "Davines",
    subtitle: "Глубокая очистка и свежесть",
    description:
      "Очищающий шампунь Davines SOLU подходит для глубокого очищения волос и кожи головы от загрязнений и стайлинга, оставляет ощущение свежести. Объем: 250 мл.",
    shortDescription: "Глубокое очищение волос и кожи головы от загрязнений и стайлинга.",
    variants: [{ volume: "250 мл", price: 2200 }],
    priceFrom: 2200,
    tags: ["Глубокая очистка", "Освежающий"],
    image: "/products/davines-solu-shampoo-clean.png",
    aiContext: "cleansing shampoo, Davines SOLU, deep cleansing, styling residue, refreshing, hair care",
  },
  {
    id: "proraso-shaving-soap",
    category: "aftershave",
    name: "Мыло для бритья",
    brand: "PRORASO",
    subtitle: "Для бритья с охлаждающим эффектом",
    description:
      "Мыло для бритья Proraso помогает подготовить кожу и щетину к чистому бритью, дает плотную пену и ощущение свежести. Объем: 150 мл.",
    shortDescription: "Классическое мыло для бритья с освежающим охлаждающим эффектом.",
    variants: [{ volume: "150 мл", price: 750 }],
    priceFrom: 750,
    tags: ["Для бритья", "Охлаждающий эффект"],
    image: "/products/proraso-shaving-soap-clean.png",
    aiContext: "shaving soap, Proraso, cooling effect, shaving, beard care, aftershave",
  },
];
